import axios from "axios";
import { baseUrlPostGres } from "../constant";
import HandleError from "../HandleError";
import { apiHeader } from "./ApiHeader";
import {
    IS_LOADING, SUBADMIN_LIST_SUCCESS, SUBADMIN_LIST_ERROR, CREATE_SUBADMIN_SUCCESS, CREATE_SUBADMIN_ERROR, SUBADMIN_STATUS_SUCCESS, SUBADMIN_STATUS_ERROR,
    SUBADMIN_DELETE_SUCCESS, SUBADMIN_DELETE_ERROR, SUBADMIN_VIEW_SUCCESS, SUBADMIN_VIEW_ERROR, SUBADMIN_UPDATE_SUCCESS, SUBADMIN_UPDATE_ERROR
} from "./Type";
import { apiVersion } from "src/utils/apiVersion";


export const SubadminListAction = (page, size, data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/subadmin/list?page=${page}&size=${size}`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SUBADMIN_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SUBADMIN_LIST_ERROR,
                payload: errors
            })
        })
}

export const ResetSubadminListAction = () => async (dispatch) => {
    dispatch({
        type: SUBADMIN_LIST_SUCCESS,
        payload: {}
    })
}

export const CreateSubadminAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/subadmin/create`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: CREATE_SUBADMIN_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: CREATE_SUBADMIN_ERROR,
                payload: errors.response.data
            })
        })
}

export const ResetCreateSubadminAction = () => async (dispatch) => {
    dispatch({
        type: CREATE_SUBADMIN_SUCCESS,
        payload: {}
    })
}

export const SubadminStatusAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/subadmin/active-inactive`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SUBADMIN_STATUS_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SUBADMIN_STATUS_ERROR,
                payload: errors.response.data
            })
        })
}

export const ResetSubadminStatusAction = () => async (dispatch) => {
    dispatch({
        type: SUBADMIN_STATUS_SUCCESS,
        payload: {}
    })
}

export const SubadminDeleteAction = (id) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .delete(`${baseUrlPostGres()}/admin/${apiVersion.v1}/subadmin/delete?userid=${id}`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SUBADMIN_DELETE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SUBADMIN_DELETE_ERROR,
                payload: errors.response.data
            })
        })
}

export const ResetSubadminDeleteAction = () => async (dispatch) => {
    dispatch({
        type: SUBADMIN_DELETE_SUCCESS,
        payload: {}
    })
}

export const SubadminViewAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/subadmin/view`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SUBADMIN_VIEW_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SUBADMIN_VIEW_ERROR,
                payload: errors.response.data
            })
        })
}

export const ResetSubadminViewAction = () => async (dispatch) => {
    dispatch({
        type: SUBADMIN_VIEW_SUCCESS,
        payload: {}
    })
}

export const SubadminUpdateAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/subadmin/update`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SUBADMIN_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SUBADMIN_UPDATE_ERROR,
                payload: errors.response.data
            })
        })
}

export const ResetSubadminUpdateAction = () => async (dispatch) => {
    dispatch({
        type: SUBADMIN_UPDATE_SUCCESS,
        payload: {}
    })
}

